import { AfterContentInit, Directive, EventEmitter, Input, Output } from "@angular/core";
import { AbstractControl, FormControl } from "@angular/forms";
import { ApplicationContextService, PermissionType, RolePermissionService } from "lib-core-shared";

@Directive({
    selector: 'app-control-base'
})
export class ControlBaseDirective implements AfterContentInit {
    @Input() public heightAuto: boolean =false;
    @Input() control: AbstractControl = {} as FormControl;
    get formCtrl(): FormControl {
      return this.control as FormControl;
    }
    @Input() permission!: string; //the permission required to enable
    @Input() isPermissionBranchSpecific: boolean = false; //does the permission depend on the branch. E.G a user can have the permission in SNG but not SNH
    branchPermission!: string;
    public defaultMaxLength: number = 524288;//524288 is default max length for html form inputs
    @Input() maxLength: number = this.defaultMaxLength;
    @Input() public idName: string = '';
    @Input() public hideValue = false;
    @Input() public label: string = '';
    @Input() public overrideLabel: boolean = false;
    @Input() public crud: boolean = false;
    @Input() public disabled:any = null;
    @Input() ignoreLabel: boolean = false;
    @Input() labelBlock: boolean = true;
    @Input() externalTrigger: boolean = false;
    @Input() verticallyAlign: boolean = true;
    @Input() idField: string = 'id';
    @Input() fieldDescription: string = 'name'; //defines which property is used to display options in select dropdowns
    @Input() width: string = '100%'; // '150px';
    @Input() labelOpacity: string = '1';
    @Input() placeHolder: string = ''
    @Output() changedEvent: EventEmitter<any>  = new EventEmitter<any>();
    @Input() public shortLengthCount: boolean = false;
    public hasPermission!: boolean;
    public fieldDescriptionLevelTwo!: string; //defines which nested property is used alongside fieldDescription
    constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) {
    }

    public get permissionType() {
      return PermissionType;
    }
    public ngAfterContentInit(): void {

      //if the app is running in a jwt context(public website), we won't have permissions like we do for internal apps using Azure AD
      if(this.applicationContext.isJwtContext()){
        this.control.enable();
        return
      }

      if (this.permission) {

        //if we are embedded and we have a branch
        //and the permission is branch specific
        //then add the branch code to the permission name
        if(this.isPermissionBranchSpecific && this.applicationContext.isApplicationEmbedded() && this.applicationContext.getBranchCodeFromUrl() != 'ALL'){
          this.branchPermission = `${this.permission}.${this.applicationContext.getBranchCodeFromUrl()}`;
        }

        if (this.control && Object.keys(this.control).length) {
          this.control.disable();
        }

        this.hasPermission = this.roleService.userHasPermission(this.branchPermission ? this.branchPermission : this.permission);

        if(this.hasPermission == true){
          if (this.control && this.control.enable) {
            this.control.enable();
          }
        }
        
      }else{
        if (this.control) {
          if (typeof this.control.enable !== "undefined") { 
            this.control.enable();
         }
        }
      }


      if(this.fieldDescription && this.fieldDescription.indexOf('.') != -1){
        let splitFieldDescription = this.fieldDescription.split('.');

        this.fieldDescription = splitFieldDescription[0];

        if(splitFieldDescription[1]){
          this.fieldDescriptionLevelTwo = splitFieldDescription[1];
        }
      }
    }
}